import CoffeeIcon from '~/images/md-icons/local_cafe/materialicons/24px.svg';
import MarkChatRead from '~/images/md-icons/mark_chat_read/materialicons/24px.svg';
import PedalBikeIcon from '~/images/md-icons/pedal_bike/materialicons/24px.svg';
import SyncAltIcon from '~/images/md-icons/sync_alt/materialicons/24px.svg';

const ReplacementTileIcon = ({type, ...rest}) => {
  const ICON = {
    wait: <CoffeeIcon {...rest} />,
    message: <MarkChatRead {...rest} />,
    bike: <PedalBikeIcon {...rest} />,
    transport: <SyncAltIcon {...rest} />,
  };

  return ICON[type];
};

export default ReplacementTileIcon;
